module.exports = __webpack_public_path__ + "rfm-avatar-almost-lost.svg?c1ad37ba9040b0ed77d103fb5dcce91b";